import { createAction, props } from '@ngrx/store';

export const submitUsername = createAction(
  '[Password Recovery] Submit Username',
  props<{ username: string }>()
);

export const submitUsernameSuccess = createAction(
  '[Password Recovery] Submit Username Success',
  props<{
    username: string;
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    loginMethod: string | null;
    expiresIn: number | null;
    expiresAt: string | null;
    message: string | null;
  }>()
);

export const submitUsernameFailure = createAction(
  '[Password Recovery] Submit Username Failure',
  props<{ error: string }>()
);

export const verifyOtp = createAction(
  '[Password Recovery] Verify OTP',
  props<{ code: string }>()
);

export const verifyOtpSuccess = createAction(
  '[Password Recovery] Verify OTP Success',
  props<{
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    loginMethod: string | null;
    expiresIn: number | null;
    expiresAt: string | null;
    message: string | null;
  }>()
);

export const verifyOtpFailure = createAction(
  '[Password Recovery] Verify OTP Failure',
  props<{ error: string }>()
);

export const resendOtp = createAction('[Password Recovery] Resend OTP');

export const resendOtpSuccess = createAction(
  '[Password Recovery] Resend OTP Success',
  props<{
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    loginMethod: string | null;
    expiresIn: number | null;
    expiresAt: string | null;
    message: string | null;
  }>()
);

export const resendOtpFailure = createAction(
  '[Password Recovery] Resend OTP Failure',
  props<{ error: string }>()
);

export const setPassword = createAction(
  '[Password Recovery] Set Password',
  props<{ password: string }>()
);

export const setPasswordSuccess = createAction(
  '[Password Recovery] Set Password Success',
  props<{
    message: string | null;
    resultStatus: string | null;
  }>()
);

export const setPasswordFailure = createAction(
  '[Password Recovery] Set Password Failure',
  props<{ error: string }>()
);

export const complete = createAction('[Password Recovery] Complete');

export const reset = createAction('[Password Recovery] Reset');

export const setLoading = createAction(
  '[Password Recovery] Set Loading',
  props<{ loading: boolean }>()
);

export const setError = createAction(
  '[Password Recovery] Set Error',
  props<{ error: string | null }>()
);
